// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DirectQuoteMessage } from './DirectQuoteMessage';
import { HistoryType } from '../../Utils/History/HistoryType';
import { Message } from './Message';
export class DirectInstrumentPricesMessage extends DirectQuoteMessage {
    constructor() {
        super(Message.CODE_INSTRUMENT_PRICES);
        this.Type = HistoryType.QUOTE_INSTRUMENT_PRICES;
        this.IndicativeAuctionPrice = null;
        this.IndicativeAuctionVolume = null;
        this.LastTradedTime = null;
        this.AvgTradedPrice = null;
        this.TotalBuyQuantity = null;
        this.TotalSellQuantity = null;
        this.AuctionNumber = null;
        this.AuctionStatus = null;
        this.InitiatorType = null;
        this.InitiatorPrice = null;
        this.InitiatorQuantity = null;
        this.HighOpenInterest = null;
        this.LowOpenInterest = null;
        // #73350
        this.TradedValue = null;
        this.OffExchangeVolume = null;
        this.OffExchangeValue = null;
        // ------
        this.AuctionEndTime = null;
        this.RemainingQty = null;
        this.RemainingQtySide = null;
        // #113099
        this.LPPHigh = null;
        this.LPPLow = null;
        this.FundingRateValue = null;
        this.MarkPrice = null;
        this.NextFundingTimeUTC = null;
    }
}
